import { appStore, supportStore, useStores } from '../../stores';
import { ContactSupport } from '../../pages/Settings';
import { SupportController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { string, object } from 'yup';
import { useFileUpload } from 'use-file-upload';

const ContactSupportContainer = ({ closeModal }) => {
	const [faq, setFaq] = useState(false);
	const [sendMessage, setSendMessage] = useState(false);
	const [speakRep, setSpeakRep] = useState(false);
	const [msgSent, setMsgSent] = useState(false);
	const [file, selectFile] = useFileUpload();

	const selectClick = () => {
		selectFile({ accept: 'file/*' });
	};

	const fileReader = async (file, field, values) => {
		if (file && typeof file.source === 'string') {
			const fileToSend = await fetch(file.source)
				.then(response => response.blob())
				.then(
					blob =>
						new File([blob], 'name', {
							type: blob.type,
							lastModified: new Date(),
						})
				);
			values[field] = fileToSend;
		}
	};
	const goBack = () => {
		if (faq) {
			setFaq(false);
		} else if (sendMessage) {
			setSendMessage(false);
		} else if (speakRep) {
			setSpeakRep(false);
		} else {
			closeModal();
		}
	};

	const {
		appStore: { loading },
		supportStore,
	} = useStores();

	const faqs = supportStore.faqs;
	const showFaq = () => {
		setFaq(true);
	};

	const showSendMessage = () => {
		setSendMessage(true);
	};

	const showMsgSent = () => {
		setMsgSent(true);
	};

	const showSpeakRep = () => {
		setSpeakRep(true);
	};

	const validationSchema = () =>
		object({
			title: string().required('Title is required'),
			message: string().required('Message is required'),
		});

	const onSubmit = async payload => {
		appStore.setLoading(true);
		if (file && file.source) await fileReader(file, 'file', payload);
		const { status, errorMessage } =
			await SupportController.createSupport(payload);
		appStore.setLoading(false);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
			return showMsgSent();
		}

		MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const [category, setCategory] = useState('');
	const showCategory = i => {
		if (category === i) {
			return setCategory(' ');
		} else {
			setCategory(i);
		}
	};

	const supportMainMenu = () => {
		setFaq(false);
		setSendMessage(false);
		setMsgSent(false);
		setSpeakRep(false);
	};

	return (
		<ContactSupport
			closeModal={closeModal}
			faq={faq}
			loading={loading}
			showFaq={showFaq}
			onSubmit={onSubmit}
			validationSchema={validationSchema}
			faqData={supportStore.faqs}
			sendMessage={sendMessage}
			showSendMessage={showSendMessage}
			speakRep={speakRep}
			showSpeakRep={showSpeakRep}
			msgSent={msgSent}
			showMsgSent={showMsgSent}
			supportMainMenu={supportMainMenu}
			category={category}
			showCategory={showCategory}
			faqData2={faqs}
			goBack={goBack}
			file={file}
			selectClick={selectClick}
		/>
	);
};

export default observer(ContactSupportContainer);
